import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Policies.css';

function PrivacyPolicy() {
  return (
    <Container className="policy-page py-5">
      <h1 className="text-center mb-5">Gizlilik Politikası</h1>
      <h2 className="text-center mb-4">KVKK Aydınlatma Metni</h2>
      
      <Row className="g-4">
        <Col lg={10} className="mx-auto">
          <Card className="policy-card">
            <Card.Body>
              <section className="mb-5">
                <p>
                  Gerek web sitemizi kullanırken, gerekse başka yollarla tarafımıza iletmiş olduğunuz kişisel bilgilerinizin güvenliğinin sağlanmasına son derece önem vermektedir. 6698 Sayılı "Kişisel Verilerin Korunması Kanunu" yürürlüğe girmiştir. Anılan mevzuat ve bu mevzuatta belirtilen bir takım tanımlar hakkında sizi bilgilendirmek isteriz:
                </p>
                <ul className="policy-list">
                  <li><strong>Kişisel veri:</strong> Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi,</li>
                  <li><strong>Kişisel verilerin İşlenmesi:</strong> Kişisel verilerin tamamen veya kısmen otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden düzenlenmesi, açıklanması, aktarılması, devralınması, elde edilebilir hâle getirilmesi, sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler üzerinde gerçekleştirilen her türlü işlemi,</li>
                  <li><strong>Veri işleyen:</strong> Veri sorumlusunun verdiği yetkiye dayanarak onun adına kişisel verileri işleyen gerçek veya tüzel kişiyi,</li>
                  <li><strong>Veri kayıt sistemi:</strong> Kişisel verilerin belirli kriterlere göre yapılandırılarak işlendiği kayıt sistemini,</li>
                  <li><strong>Veri sorumlusu:</strong> Kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin kurulmasından ve yönetilmesinden sorumlu olan gerçek veya tüzel kişiyi ifade eder.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>1. Kişisel Verilerin Korunması ve Rıza Metninin Amacı ve Şirketimizin Veri Sorumlusu Konumu</h4>
                <p>
                  Alışveriş sitemizin müşterilere ilişkin kişisel veriler bakımından 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") kapsamında "veri sorumlusu" sıfatına sahip olup işbu Kişisel Verilerin Korunması ve Rıza Metni ile söz konusu Kanun uyarınca müşterilerin alışveriş sitemiz tarafından gerçekleştirilen kişisel veri işleme faaliyetleri hakkında aydınlatılması ve aşağıda 3. maddede belirtilen durumlar için açık rızalarının temini hedeflenmektedir.
                </p>
              </section>

              <section className="mb-5">
                <h4>2. Müşterilere Ait Kişisel Verilerin İşlenme Amacı</h4>
                <p>
                  Müşterilere ait kişisel veriler aşağıda ve Kanun'un 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde işlenmektedir:
                </p>
                <ul className="policy-list">
                  <li>Alışveriş sitemiz tarafından sunulan ürün ve hizmetlerden ilgili kişileri faydalandırmak için gerekli çalışmaların iş birimleri tarafından yapılması ve ilgili iş süreçlerinin yürütülmesi</li>
                  <li>Alışveriş sitemiz tarafından yürütülen ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimleri tarafından gerekli çalışmaların yapılması ve buna bağlı iş süreçlerinin yürütülmesi</li>
                  <li>Alışveriş sitemizin ticari ve/veya iş stratejilerinin planlanması ve icrası</li>
                  <li>Müşterilere daha iyi hizmet verebilme, çeşitli avantajlar sağlayıp sunma, satış, pazarlama, bilgilendirme, promosyonlar hakkında bilgi verebilme</li>
                  <li>Müşteri memnuniyeti aktivitelerinin planlanması ve icrası</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>3. Kişisel Verilerin Aktarımı</h4>
                <p>
                  Müşterilere ait kişisel veriler, Kanun'un 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde Şirket yetkilileri, iştiraklerimiz, iş ortaklarımız, tedarikçilerimiz, hissedarlarımız, kanunen yetkili kamu kurum ve kuruluşları ile özel kurumlar ile paylaşılabilecektir.
                </p>
              </section>

              <section className="mb-5">
                <h4>4. Kişisel Verilerin Saklanma Süreleri</h4>
                <p>
                  Alışveriş Sitemiz, ilgili kanunlarda ve mevzuatlarda öngörülmesi durumunda kişisel verileri bu mevzuatlarda belirtilen süre boyunca saklamaktadır. Kişisel verilerin işlenme amacı sona ermiş ve ilgili mevzuat ve Alışveriş Sitemiz'in belirlediği saklama sürelerinin sonuna gelinmişse, kişisel veriler silinmekte, yok edilmekte veya anonim hale getirilmektedir.
                </p>
              </section>

              <section>
                <h4>5. Kişisel Veri Sahibi Olarak Müşterilerin Hakları</h4>
                <p>
                  Kanun'un 11. maddesi uyarınca veri sahipleri olarak aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="policy-list">
                  <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
                  <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme</li>
                  <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
                  <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                  <li>Kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                  <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
                  <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme</li>
                </ul>
                <p>
                  Söz konusu hakların kullanımına ilişkin talepler, kişisel veri sahipleri tarafından Alışveriş Sitemize iletilebilecektir. Alışveriş sitemiz söz konusu talepleri değerlendirerek 30 gün içerisinde sonuçlandıracaktır.
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default PrivacyPolicy;